import { DELPHI_SURVEY_URL, SPECIALIST_HOSTNAME } from "../env-vars";
import type { Questionnaire, SubmissionResponse } from "../context/questionnaire/types";

export async function fetchQuestionnaire(
  token: string,
  locale: string,
): Promise<Questionnaire> {
  const url = `${DELPHI_SURVEY_URL}/${token}?locale=${locale}`;
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(
      `Failed to fetch questionnaire (${response.status}): ${response.statusText}`,
    );
  }

  return response.json();
}

export async function submitAuthenticated(
  payload: object,
  idToken: string,
): Promise<SubmissionResponse> {
  const url = `${SPECIALIST_HOSTNAME}/api/v1/survey_sessions/submit`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(
      `Authenticated submission failed (${response.status}): ${response.statusText}`,
    );
  }

  return response.json();
}

export async function submitUnauthenticated(
  payload: object,
  surveyToken: string,
): Promise<SubmissionResponse> {
  const url = `${SPECIALIST_HOSTNAME}/api/v1/survey_sessions/submit_unauthenticated`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ survey_token: surveyToken, ...payload }),
  });

  if (!response.ok) {
    throw new Error(
      `Unauthenticated submission failed (${response.status}): ${response.statusText}`,
    );
  }

  return response.json();
}
